module.exports = __webpack_public_path__ + "static/img/2829_phase_function_Paper_Points.82591fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2829_phase_function_Paper_Points.png
// module id = 3+Sz
// module chunks = 0